<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-title"><b>Dedication and Thanks</b></p>
<p class="indent_1">A writer is only as good as her editor, and my history has shown this to be true. Prior to writing for AQS Publishing, I wrote Missouri travel books for Virginia Publishing and Reedy Press in St. Louis, Missouri. That was where I learned all that an editor does to make an author look good.</p>
<p class="indent_1">Writing nonfiction requires researching a subject and then writing about what’s been learned. Fact checking is necessarily a priority. That was true both with the travel books and also with the 100 Series I wrote for AQS Publishing.</p>
<p class="indent_1">When I started writing fiction for AQS, there seemed to be a series of editors that came and went. Each one was different, but I was always pleased that they remained respectful of my story line and concentrated on grammatical corrections instead. Each had their own style of editing, but as a new fiction author, I was always grateful for their advice.</p>
<p class="indent_1">Andi Reynolds was my first editor at AQS. She and Meredith Schroeder lobbied successfully that quilt fiction needed to be a part of their offerings. They warned me that I was their guinea pig in this new venture, but my first series enjoyed immediate success. Thank you both!</p>
<p class="indent_1">Elaine Brelsford has been my editor for the last few series, and I can only say that she’s a gem. She knows my writing style, has good taste, and shares my success. Thank you, Elaine!</p>
<p class="indent_1">I don’t think editors get enough credit for all they do. I’m not saying that just because I have a son who is one, but because I know how an editor can make or break the outcome of a published piece. To all my past and present editors, I dedicate this book to you! Thank you!</p>
<p class="indent_1">Thanks also to the Coulson’s of The White Gull Inn for letting us show their beautiful facility on the cover of this book.</p>
<p class="indent_1"><i>—Ann Hazelwood</i></p>
<p class="fig"><img alt="" src="images/pg5.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0002_ded.vue?3d49bfa5